/**
 * Saga for launching all global modals by a window hash
 *
    http://an-dev.urbn.com/#email-sign-up
    http://an-dev.urbn.com/#sign-up
    http://an-dev.urbn.com/#sign-in
    http://an-dev.urbn.com/#order-inquiry
    http://an-dev.urbn.com/#ugc-photo-upload
 */

import { modalHashes } from '../utils/globalModalHashLauncherConfig';
import { isWebview } from '../utils/cookieUtils';
import { pushModalTransition } from '../actions/modalActions';
import { select } from 'redux-saga/effects';
import { removeHash } from '../utils/routerUtils';

export function* modalHashLauncherSaga() {
    const state = yield select();
    const hash = window.location.hash;
    /* If the page is a webview, don't trigger any modals */
    if(isWebview()) { return false; }

    if (hash) {
        // hash also includes the query params, strip them
        const cleanedHash = hash.split(/\?|=/)[0];

        // if hash is not a valid modal hash, ignore
        if (!_.has(modalHashes, cleanedHash)) {
            return false;
        }

        // prevent giveaway modals on login page
        if (window.isLoginPage && cleanedHash.includes('giveaway')) {
            return false;
        }

        const initFunction = modalHashes[cleanedHash];

        if (initFunction.event) {
            document.dispatchEvent(new CustomEvent(initFunction.event));
            removeHash();
            return true;
        }

        // Allow global modal hashes to be an object with an async:true property
        // and a load function so we an use dynamic imports for hash driven
        // modals
        const loadInitFunction = initFunction.dynamic ?
            initFunction.load(state) :
            Promise.resolve(initFunction, state);

        loadInitFunction.then(({ init, overrides = {} }) => {

            const payload = pushModalTransition(init, overrides);
            $.event.trigger({
                type: payload.type,
                payload: payload
            });
        });
    }
}
